/**
 * Photos API — presigned URL fetch.
 *
 * Sprint L. The UI never gets raw S3 keys. Each photo render fetches
 * a short-lived presigned URL via this endpoint. We trade one
 * round-trip-per-photo for not having to expose object keys (or
 * configure S3 bucket policy) to the browser.
 *
 * Defaults to `variant: "thumb"` since the dominant UI use is grid /
 * table thumbnails. Full-size variant lives behind the same endpoint
 * for detail-view rendering.
 */

import { api, type RequestOptions } from "./client";


export interface PhotoUrlDto {
  photo_id:   string;
  variant:    "full" | "thumb";
  url:        string;
  expires_in: number;
}


export const photosApi = {
  getUrl(
    photoId: string,
    variant: "full" | "thumb" = "thumb",
    opts?: RequestOptions,
  ): Promise<PhotoUrlDto> {
    return api.get<PhotoUrlDto>(`/photos/${photoId}/url?variant=${variant}`, opts);
  },
};
